(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Ticket_statusDialogController', Ticket_statusDialogController);

    Ticket_statusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Ticket_status'];

    function Ticket_statusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Ticket_status) {
        var vm = this;

        vm.ticket_status = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.ticket_status.id !== null) {
                Ticket_status.update(vm.ticket_status, onSaveSuccess, onSaveError);
            } else {
                Ticket_status.save(vm.ticket_status, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:ticket_statusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
